import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, InputBase, InputLabel, List, ListItem, ListItemText, MenuItem, Paper, Radio, RadioGroup, Select, Typography } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';

import { openSnackbar } from "../store/slices/SnackbarSlice";

import { RootState } from '../store';

import { DialogBuscarAmparo } from './DialogBuscarAmparo';

import { InputSearchButtonsStyle, InputSearchStyle } from '../styles/FormStyle';

import { NuevoAcuerdo } from '../connections/tribunal/AcuerdoConnection';
import { ObtenerMateria } from '../connections/catalogos/MateriaConnection';
import { BuscarIrregular } from '../connections/recepcion/IrregularConnection';
import { BuscarExpediente } from '../connections/recepcion/ExpedienteConnection';
import { ObtenerAutoridadesMaterias } from '../connections/catalogos/AutoridadConnection';
import { BuscarExhortoRecibido } from '../connections/recepcion/ExhortoRecibidoConnection';

import { MateriaProps } from '../interfaces/catalogos/MateriaInterface';
import { AutoridadProps } from '../interfaces/catalogos/AutoridadInterface';
import { BuscarIrregularResponse, defaultIrregularResponse } from '../interfaces/recepcion/IrregularInterface';
import { AmparoProps, BuscarAmparoResponse, defaultBuscarAmparo } from '../interfaces/recepcion/AmparoInterface';
import { BuscarExpedienteResponse, defaultExpedienteResponse } from '../interfaces/recepcion/ExpedienteInterface';
import { BuscarExhortoRecibidoResponse, defaultExhortoRecibidoResponse } from '../interfaces/recepcion/ExhortoRecibidoInterface';

interface Props {
    openDialog:          boolean;
    handleCloseDialog:   () => void;
}

type TipoBusquedaType = '' | 'expediente' | 'irregular' | 'amparo' | 'exhortoRecibido';

export const DialogNuevoAcuerdo = ( { openDialog, handleCloseDialog }: Props ) => {

    const dispatch = useDispatch();
    
    const navigate = useNavigate(); 

    const { idUnidad } = useSelector( ( state: RootState ) => state.auth );

    const [loading, setLoading] = useState( false );

    const [loadingGuardar, setLoadingGuardar] = useState(false);

    const [tipoBusqueda, setTipoBusqueda] = useState<TipoBusquedaType>( '' );  

    const [materia, setMateria] = useState(0);
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [autoridad, setAutoridad] = useState(0);
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );
    
    const [numeroExpediente, setNumeroExpediente] = useState( '' );
    const [expediente, setExpediente] = useState<BuscarExpedienteResponse>( defaultExpedienteResponse );

    const [numeroExhorto, setNumeroExhorto] = useState( '' );
    const [exhortoRecibido, setExhortoRecibido] = useState<BuscarExhortoRecibidoResponse>( defaultExhortoRecibidoResponse );

    const [numeroIrregular, setNumeroIrregular] = useState( '' );
    const [irregular, setIrregular] = useState<BuscarIrregularResponse>( defaultIrregularResponse );

    const [numeroAmparo, setNumeroAmparo] = useState( '' );
    const [amparo, setAmparo] = useState<BuscarAmparoResponse>( defaultBuscarAmparo );

    const [openDialogBuscarAmparo, setOpenDialogBuscarAmparo] = useState( false );

    const handleGenerarAcuerdo = async () => {      

        setLoadingGuardar(true);      
        
        await NuevoAcuerdo({ 
            idExpediente: expediente.idExpediente,
            idExhortoRecibido: exhortoRecibido.idExhortoRecibido,
            idAmparo: amparo.idAmparo,
            idIrregular: irregular.idIrregular,
        })
        .then( resp => {

            setTimeout(() => {

                const { success, message, idAcuerdo } = resp;

                if( success ){
                    
                    navigate(`/tribunal/acuerdo/elaborar/${ idAcuerdo }`);

                }
                else{

                    dispatch( openSnackbar({ message: message, variant: 'error' }));  
                    setLoadingGuardar( false );
                }

            }, 700);  

        });
               
    }

    const handleBuscarExpediente = async () => {
     
        setLoading( true ); 

        await BuscarExpediente({ numeroExpediente, idAutoridad: autoridad }).then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {

                    handleClear();

                    setExpediente( resp );
                    setLoading( false ); 

                }, 700);  

            }
            else {

                setTimeout(() => {

                    handleClear();            
                    dispatch( openSnackbar({ message: message, variant: 'error' }));  
                    setLoading( false ); 

                }, 700);  

            }

        });    

    }

    const handleBuscarExhortoRecibido = async () => {

        setLoading( true ); 

        await BuscarExhortoRecibido({ numeroExhortoRecibido: numeroExhorto, idAutoridad: autoridad }).then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {

                    handleClear();

                    setExhortoRecibido( resp );
                    setLoading( false ); 

                }, 700);  

            }
            else {

                setTimeout(() => {

                    handleClear();
                    dispatch( openSnackbar({ message: message, variant: 'error' }));  
                    setLoading( false ); 

                }, 700);  

            }

        });    

    }

    const handleBuscarIrregular = async () => {

        setLoading( true ); 

        await BuscarIrregular({ numeroIrregular: numeroIrregular, idAutoridad: autoridad }).then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {

                    handleClear();

                    setIrregular( resp );
                    setLoading( false ); 

                }, 700);  

            }
            else {

                setTimeout(() => {

                    handleClear();
                    dispatch( openSnackbar({ message: message, variant: 'error' }));  
                    setLoading( false ); 

                }, 700);  

            }

        });    

    }

    const seleccionarAmparo = ( amparo: AmparoProps ) => { 

        if( amparo.idAmparo !== 0){

            setNumeroAmparo( amparo.numeroAmparo ?? amparo.numeroAmparoOrigen ); 
            setAmparo({ 
                success: true,
                message: 'Se encontró el amparo correctamente',
                ...amparo 
            }); 
        }
        else{            
            dispatch( openSnackbar({ message: 'No se encontró el número de amparo', variant: 'error' }));  
        }

    }

    const handleClear = () => {
        
        setMateria( 0 );
        setAutoridad( 0 );
        setAutoridadArray( [] );

        setNumeroExpediente( '' );
        setExpediente( defaultExpedienteResponse );

        setNumeroExhorto( '' );
        setExhortoRecibido( defaultExhortoRecibidoResponse );      
        
        setNumeroIrregular( '' );
        setIrregular( defaultIrregularResponse );

        setNumeroAmparo( '' );
        setAmparo( defaultBuscarAmparo );

    }

    const handleCerrarDialog = () => {
        
        handleClear();
        handleCloseDialog();
        setTipoBusqueda('');

    }

    const handleChangeTipoBusqueda = ( value: TipoBusquedaType ) => {

        setNumeroExpediente( '' );
        setExpediente( defaultExpedienteResponse );

        setNumeroExhorto( '' );
        setExhortoRecibido( defaultExhortoRecibidoResponse );
    
        setNumeroIrregular( '' );
        setIrregular( defaultIrregularResponse );

        setNumeroAmparo( '' );
        setAmparo( defaultBuscarAmparo );

        setTipoBusqueda( value );
    }

    useEffect(() => {
        
        async function Obtener(){    

            await ObtenerMateria().then( resp => {              
                setMateriaArray( resp );                 
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
           
        async function Obtener(){    

            setAutoridad( 0 );
            setAutoridadArray( [] );

            await ObtenerAutoridadesMaterias( materia ).then( resp => {              
                setAutoridadArray( resp );                 
            });

        }

        if( materia !== 0 ){
            Obtener();
        }

    }, [ materia ]);

    return (
        <>

            <Dialog open={ openDialog } maxWidth='md' fullWidth={true} >

                <DialogTitle>Nuevo Acuerdo</DialogTitle>
            
                <DialogContent>
                    
                    <Grid container spacing={3} mt={1}>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <FormControl>

                                <FormLabel>Generar acuerdo para:</FormLabel>
                                <RadioGroup row>                                    
                                  
                                    <FormControlLabel 
                                        label="Expediente" 
                                        control={ <Radio checked={ tipoBusqueda === 'expediente' } 
                                        onChange={ () => handleChangeTipoBusqueda('expediente') } />} 
                                    />                                  
                                   
                                    {
                                        ( idUnidad === 1 )
                                        &&
                                            <FormControlLabel 
                                                label="Exhorto recibido" 
                                                control={ <Radio checked={ tipoBusqueda === 'exhortoRecibido' } 
                                                onChange={ () => handleChangeTipoBusqueda('exhortoRecibido') } />} 
                                            />                                         
                                    }     

                                    {
                                        ( idUnidad === 3 )
                                        &&
                                            <FormControlLabel 
                                                label="Amparo" 
                                                control={ <Radio checked={ tipoBusqueda === 'amparo' } 
                                                onChange={ () => handleChangeTipoBusqueda('amparo') } />} 
                                            />                                     
                                    }  

                                    {
                                        ( idUnidad === 2 || idUnidad === 5 )
                                        &&
                                            <FormControlLabel 
                                                label="Irregular" 
                                                control={ <Radio checked={ tipoBusqueda === 'irregular' } 
                                                onChange={ () => handleChangeTipoBusqueda('irregular') } />} 
                                            />
                                    }

                                </RadioGroup>

                            </FormControl>

                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                                                                    
                            <FormControl required fullWidth>
                                
                                <InputLabel>Materia</InputLabel>
                            
                                <Select                                                                          
                                    label="Materia"
                                    value={ materia }
                                    onChange={ ( e ) => setMateria( parseInt( e.target.value.toString() ) ) }
                                >
                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>                        
                                    {
                                        materiaArray
                                        .filter( (e) => e.idMateria === 5 || e.idMateria === 6 )
                                        .map( ( e ) => (
                                            <MenuItem key={ e.idMateria } value={ e.idMateria }>{ e.descripcion }</MenuItem>                                                        
                                        ))
                                    }                     
                                    
                                </Select>

                            </FormControl>

                        </Grid>   

                        <Grid size={{ xs: 12, md: 6 }}>
                        
                            <FormControl required fullWidth>
                                
                                <InputLabel>Autoridad</InputLabel>
                            
                                <Select                                                                          
                                    label="Autoridad"
                                    value={ autoridad }
                                    onChange={ ( e ) => setAutoridad( parseInt( e.target.value.toString() ) ) }
                                    disabled={ materia === 0 }
                                >
                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>                        
                                    {
                                        autoridadArray.map( ( e ) => (
                                            <MenuItem key={ e.idAutoridad } value={ e.idAutoridad }>{ e.descripcion }</MenuItem>                                                        
                                        ))
                                    }                     
                                    
                                </Select>

                            </FormControl>

                        </Grid>         

                        {/* ---------------------  Busqueda por expediente  -------------------------------------- */}
                        
                        {
                            tipoBusqueda === 'expediente' 
                            && 
                                <Grid size={12}> 

                                    <Paper
                                        component="div"
                                        sx={ InputSearchStyle }
                                    >                    
                                        
                                        <InputBase 
                                            sx={{ ml: 1, flex: 1 }}                        
                                            placeholder="Buscar por número de expediente"     
                                            value={ numeroExpediente } 
                                            onChange={ ( e ) => { setNumeroExpediente( e.target.value ) }}
                                        />

                                        <Button 
                                            type="button" 
                                            variant='contained'                                  
                                            size='small'
                                            sx={ InputSearchButtonsStyle } 
                                            loading={ loading }
                                            disabled={ autoridad === 0 }
                                            onClick={ handleBuscarExpediente }
                                        >
                                            <SearchIcon />
                                        </Button>            

                                    </Paper>
                                    
                                </Grid>
                        }         

                        {
                            expediente.success
                            &&
                                <>

                                    <Grid size={{ md: 6, xs: 12 }}>
    
                                        <List disablePadding>
                            
                                            <ListItem sx={{ py: 0, px: 0 }}>
    
                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de expediente: </Typography> }
                                                    secondary={ 
                                                        expediente.numeroFolio
                                                        ?
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { expediente.numeroExpediente } (F. { expediente.numeroFolio }) </Typography> 
                                                        :
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { expediente.numeroExpediente } </Typography> 
                                                    }
                                                />
    
                                            </ListItem>
    
                                        </List>
                                        
                                    </Grid>           
                                    
                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>
                            
                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de juicio: </Typography> }
                                                    secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { expediente.tipoJuicio } </Typography> }
                                                />

                                            </ListItem>

                                        </List>
                                    
                                    </Grid> 

                                    {
                                        expediente.actores.length !== 0 
                                        &&                              
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>
                                    
                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Actor(es): </Typography> }
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            expediente.actores.map( ( actor, index ) => (
                                                                                <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                                                    <Typography color='primary' variant='subtitle2' fontWeight={'bold'}> { actor } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }
                                                                    </List>
                                                                </>
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>
                                            
                                            </Grid> 
                                    }

                                    {
                                        expediente.demandados.length !== 0 
                                        &&
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>
                                    
                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Demandado(s): </Typography> }
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            expediente.demandados.map( ( demandado, index ) => (
                                                                                <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                                                    <Typography color='primary' variant='subtitle2' fontWeight={'bold'}> { demandado } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }
                                                                    </List>
                                                                </>
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>
                                            
                                            </Grid> 
                                    }

                                </>
                        }

                        {/* ---------------------  Busqueda por exhorto recibido  -------------------------------------- */}
                          
                        {
                            tipoBusqueda === 'exhortoRecibido' 
                            && 
                                <Grid size={12}> 

                                    <Paper
                                        component="div"
                                        sx={ InputSearchStyle }
                                    >                    
                                        
                                        <InputBase 
                                            sx={{ ml: 1, flex: 1 }}                        
                                            placeholder="Buscar por número de exhorto"     
                                            value={ numeroExhorto } 
                                            onChange={ ( e ) => setNumeroExhorto( e.target.value ) }
                                        />

                                        <Button 
                                            type="button" 
                                            variant='contained'                                  
                                            size='small'
                                            sx={ InputSearchButtonsStyle } 
                                            loading={ loading }
                                            disabled={ autoridad === 0 }
                                            onClick={ handleBuscarExhortoRecibido }
                                        >
                                            <SearchIcon />
                                        </Button>            

                                    </Paper>
                                    
                                </Grid>
                        }      

                        {
                            exhortoRecibido.success
                            &&
                                <>

                                    <Grid size={{ md: 6, xs: 12 }}>
    
                                        <List disablePadding>
                            
                                            <ListItem sx={{ py: 0, px: 0 }}>
    
                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de exhorto: </Typography> }
                                                    secondary={ 
                                                        exhortoRecibido.numeroFolio
                                                        ?
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.numeroExhorto } (F. { exhortoRecibido.numeroFolio }) </Typography> 
                                                        :
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.numeroExhorto } </Typography> 
                                                    }
                                                />
    
                                            </ListItem>
    
                                        </List>
                                        
                                    </Grid>         

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>
                            
                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de juicio: </Typography> }
                                                    secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.tipoJuicio } </Typography> }
                                                />

                                            </ListItem>

                                        </List>
                                    
                                    </Grid>   
                                    
                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>
                            
                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de expediente de origen: </Typography> }
                                                    secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.numeroExpedienteOrigen } </Typography> }
                                                />

                                            </ListItem>

                                        </List>
                                    
                                    </Grid> 

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>
                            
                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Autoridad del exhorto: </Typography> }
                                                    secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.autoridadExhortoRecibido } </Typography> }
                                                />

                                            </ListItem>

                                        </List>
                                    
                                    </Grid>             

                                    {
                                        exhortoRecibido.actores.length !== 0 
                                        &&                              
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>
                                    
                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Actor(es): </Typography> }
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            exhortoRecibido.actores.map( ( actor, index ) => (
                                                                                <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                                                    <Typography color='primary' variant='subtitle2' fontWeight={'bold'}> { actor } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }
                                                                    </List>
                                                                </>
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>
                                            
                                            </Grid> 
                                    }

                                    {
                                        exhortoRecibido.demandados.length !== 0 
                                        &&
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>
                                    
                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Demandado(s): </Typography> }
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            exhortoRecibido.demandados.map( ( demandado, index ) => (
                                                                                <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                                                    <Typography color='primary' variant='subtitle2' fontWeight={'bold'}> { demandado } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }
                                                                    </List>
                                                                </>
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>
                                            
                                            </Grid> 
                                    }

                                </>
                        }
                
                        {/* ---------------------  Busqueda por irregular  -------------------------------------- */}
                          
                        {
                            tipoBusqueda === 'irregular' 
                            && 
                                <Grid size={12}> 

                                    <Paper
                                        component="div"
                                        sx={ InputSearchStyle }
                                    >                    
                                        
                                        <InputBase 
                                            sx={{ ml: 1, flex: 1 }}                        
                                            placeholder="Buscar por número de irregular"     
                                            value={ numeroIrregular } 
                                            onChange={ ( e ) => setNumeroIrregular( e.target.value ) }
                                        />

                                        <Button 
                                            type="button" 
                                            variant='contained'                                  
                                            size='small'
                                            sx={ InputSearchButtonsStyle } 
                                            loading={ loading }
                                            disabled={ autoridad === 0 }
                                            onClick={ handleBuscarIrregular }
                                        >
                                            <SearchIcon />
                                        </Button>            

                                    </Paper>
                                    
                                </Grid>
                        }      

                        {
                            irregular.success
                            &&
                                <>

                                    <Grid size={{ md: 6, xs: 12 }}>
    
                                        <List disablePadding>
                            
                                            <ListItem sx={{ py: 0, px: 0 }}>
    
                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de irregular: </Typography> }
                                                    secondary={ 
                                                        irregular.numeroExpediente
                                                        ?
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { irregular.numeroIrregular } (Exp. { irregular.numeroExpediente }) </Typography> 
                                                        :
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { irregular.numeroIrregular } </Typography> 
                                                    }
                                                />
    
                                            </ListItem>
    
                                        </List>
                                        
                                    </Grid>       

                                    {
                                        irregular.actores.length !== 0 
                                        &&                              
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>
                                    
                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Actor(es): </Typography> }
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            irregular.actores.map( ( actor, index ) => (
                                                                                <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                                                    <Typography color='primary' variant='subtitle2' fontWeight={'bold'}> { actor } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }
                                                                    </List>
                                                                </>
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>
                                            
                                            </Grid> 
                                    }

                                    {
                                        irregular.demandados.length !== 0 
                                        &&
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>
                                    
                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Demandado(s): </Typography> }
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            irregular.demandados.map( ( demandado, index ) => (
                                                                                <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                                                    <Typography color='primary' variant='subtitle2' fontWeight={'bold'}> { demandado } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }
                                                                    </List>
                                                                </>
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>
                                            
                                            </Grid> 
                                    }

                                </>
                        }

                        {/* -------------------------  Busqueda por amparo  ------------------------------------- */}

                        {
                            tipoBusqueda === 'amparo' 
                            && 
                                <Grid size={12}> 

                                    <Paper
                                        component="div"
                                        sx={ InputSearchStyle }
                                    >                    
                                        
                                        <InputBase 
                                            sx={{ ml: 1, flex: 1 }}                        
                                            placeholder="Buscar amparo por número auxiliar, número de origen, número de expediente"     
                                            value={ numeroAmparo } 
                                            onChange={ ( e ) => setNumeroAmparo( e.target.value ) }
                                            disabled
                                        />

                                        <Button 
                                            type="button" 
                                            variant='contained'                                  
                                            size='small'
                                            sx={ InputSearchButtonsStyle } 
                                            loading={ loading }
                                            disabled={ autoridad === 0 }
                                            onClick={ () => setOpenDialogBuscarAmparo( true ) }
                                        >
                                            <SearchIcon />
                                        </Button>            

                                    </Paper>
                                    
                                </Grid>
                        }      

                        {
                            amparo.success
                            &&
                                <Grid size={{ md: 12, xs: 12 }}>

                                    <Grid container spacing={3}>

                                        {
                                            amparo.numeroAmparo
                                            &&
                                                <Grid size={{ md: 6, xs: 12 }}>

                                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número auxiliar de amparo: </Typography>
                                                    <Typography variant='subtitle2' fontWeight={'bold'}> { amparo.numeroAmparo } </Typography>                                            

                                                </Grid>
                                        }

                                        {
                                            ( !amparo.numeroAmparo && amparo.numeroAmparoOrigen )
                                            &&
                                                <Grid size={{ md: 6, xs: 12 }}>

                                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de amparo de origen: </Typography>
                                                    <Typography variant='subtitle2' fontWeight={'bold'}> { amparo.numeroAmparoOrigen } </Typography>                                            

                                                </Grid>
                                        }

                                        {
                                            ( amparo.numeroAmparoOrigen && amparo.idTipoAmparo !== 1 )
                                            &&
                                                <Grid size={{ md: 6, xs: 12 }}>

                                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de origen del amparo: </Typography>
                                                    <Typography variant='subtitle2' fontWeight={'bold'}> { amparo.numeroAmparoOrigen } </Typography>                                            

                                                </Grid>
                                        }    

                                        {
                                            amparo.numeroExpediente
                                            &&
                                                <Grid size={{ md: 6, xs: 12 }}>

                                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de expediente: </Typography>
                                                    <Typography variant='subtitle2' fontWeight={'bold'}> { amparo.numeroExpediente } </Typography>                                            

                                                </Grid>
                                        }                           
                                    
                                        <Grid size={{ md: 6, xs: 12 }}>
                                                
                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de amparo: </Typography> 
                                            <Typography variant='subtitle2' fontWeight={'bold'}> { amparo.tipoAmparo } </Typography>                                                   

                                        </Grid>                                   
                                    
                                        <Grid size={{ md: 6, xs: 12 }}>
                                                
                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Autoridad del amparo: </Typography> 
                                            <Typography variant='subtitle2' fontWeight={'bold'}> { amparo.autoridadAmparo } </Typography>                                                   

                                        </Grid>         

                                        {
                                            amparo.partes.length !== 0
                                            &&
                                                <Grid size={{ md: 6, xs: 12 }}>
                                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Partes: </Typography> 

                                                    <List disablePadding>
                                                        {                                                            
                                                            amparo.partes.map( ({ persona, tipoParte }, index ) => (
                                                                <ListItem key={ index } disableGutters>
                                                                    <ListItemText>
                                                                        <Typography variant='subtitle2' fontWeight={'bold'}>{ persona }</Typography>
                                                                        <Typography variant='body2'>({ tipoParte })</Typography>
                                                                    </ListItemText>                                                                         
                                                                </ListItem>
                                                            ))
                                                        }
                                                    </List>                                       

                                                </Grid>
                                        }                          

                                    </Grid>
                                
                                </Grid>
                        }

                    </Grid>

                </DialogContent>

                <DialogActions>

                    <Button color='secondary' disabled={ loadingGuardar } onClick={ handleCerrarDialog }>Cancelar</Button>

                    <Button 
                        variant="contained" 
                        loading={ loadingGuardar } 
                        onClick={ handleGenerarAcuerdo }
                        disabled={
                            tipoBusqueda === '' ||
                            ( autoridad === 0 && !expediente.success && !exhortoRecibido.success && !irregular.success && !amparo.success ) ||
                            ( tipoBusqueda === 'expediente' && !expediente.success ) ||
                            ( tipoBusqueda === 'exhortoRecibido' && !exhortoRecibido.success ) ||
                            ( tipoBusqueda === 'irregular' && !irregular.success ) ||
                            ( tipoBusqueda === 'amparo' && !amparo.success )
                        }
                    >
                        Guardar
                    </Button>

                </DialogActions>

            </Dialog>
            
            <DialogBuscarAmparo
                autoridad={ autoridad }
                openDialog={ openDialogBuscarAmparo } 
                handleCloseDialog={ () => setOpenDialogBuscarAmparo( false ) } 
                seleccionarAmparo={ seleccionarAmparo }
            /> 

        </>
    )
}